export function percentage(value) {
  if (!value) return "0%"
  return `${value * 100}%`
}

export function price(value) {
  value = Number(value)
  return `¥${value}`
}
